//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'clean',
  components: {
  },
  data () {
    return {
      type:2,
      count:[],
    }
  },
  created(){
   
  },
  mounted(){
    this.getOrderCount();

  },
  methods:{
    getOrderCount(){
      this.$api.getOrderCount({type:this.type,store_scope:1}).then((res)=>{
        this.count = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/clean.vue